import { isRouteErrorResponse, useRouteError } from 'react-router'
import { CatalogError } from '@/catalog/validate'
import { Button } from '@/components/ui/Button'
import { AlertIcon, RefreshIcon } from '@/components/ui/icons'
import { NotFoundContent } from './NotFoundPage'

/** Rendered inside the site layout when a page fails to load or render. */
export function RouteError() {
  const error = useRouteError()

  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundContent />

  console.error(error)
  const catalogFailed = error instanceof CatalogError || error instanceof TypeError || error instanceof SyntaxError

  return (
    <div className="container-page grid min-h-[60vh] place-items-center py-16 text-center">
      <title>Something went wrong · Zarcade</title>
      <div role="alert" className="flex max-w-md flex-col items-center">
        <span className="grid size-14 place-items-center rounded-2xl bg-flare/15 text-flare">
          <AlertIcon size={26} />
        </span>
        <h1 className="mt-5 text-3xl font-bold">
          {catalogFailed ? 'We couldn’t load the game library' : 'Something went wrong'}
        </h1>
        <p className="mt-3 text-fg-muted">
          {catalogFailed
            ? 'Check your connection and try again. If the problem continues, the arcade may be undergoing maintenance.'
            : 'An unexpected error occurred while loading this page.'}
        </p>
        <Button className="mt-8" onClick={() => window.location.reload()}>
          <RefreshIcon size={18} />
          Reload
        </Button>
      </div>
    </div>
  )
}
